import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { signupContentStyles } from './styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { queryStringParser } from '../utils/queryStringParser';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { signSetAction } from '../../../store/signup/actions';
import { PATH } from '../../../routes';
import MiddleContent from './MiddleContent';
import Logo from './Logo';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { pushEvent } from '../../../utils/clevertapUtils';
import {
    CLICK_START_BUTTON,
    PAGE_ORGANIZATION_HOME,
    DONOR_SIGNUP_BUTTON_CLICKED,
} from '../../../utils/clevertapEvents';
import { useRouteConfig } from '../utils/useRouteConfig';
import { Theme } from '@material-ui/core/styles';
import { webConfig } from '../../../webConfig';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';
import { useFullStoryIdentity } from '../utils/useFullStoryIdentity';

const GIVELIFY_DONOR_SIGNUP_PAGE_URL = webConfig.givelifyDonorSignupPageUrl;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        borderedButton: {
            lineHeight: `${theme.spacing(5)}px`,
            borderRadius: 72.5,
            minHeight: 86,
            textAlign: 'center',
            fontSize: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0px 0px 8px rgba(131, 131, 131, 0.4)',
            transition: '0.5s all ease-in-out',
            '&:hover': {
                backgroundColor: '#f6f6f6',
            },
        },
        middleContent: {
            marginTop: -24,
            marginBottom: 'inherit',
            '& .text': {
                padding: 16,
            },
            '& .logo': {
                marginTop: 0,
                marginBottom: 54.8,
            },
            '& .MuiTypography-h2': {
                fontSize: 32,
                marginBottom: 55,
                fontWeight: 700,
            },
            '& .margin-bottom': {
                marginBottom: theme.spacing(4),
            },
            // '& .left-button': {
            //     paddingRight: 18,
            // },
            // '& .right-button': {
            //     paddingLeft: 18,
            // },
            // '& .line-break': {
            //     marginBottom: 10,
            // },
            // [theme.breakpoints.down('xs')]: {
            //     '& .left-button': {
            //         marginBottom: theme.spacing(3),
            //         paddingRight: 0,
            //     },
            //     '& .right-button': {
            //         paddingLeft: 0,
            //     },
            // },
        },
    }),
);

const SignupHome: React.FC = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const { content, logo } = signupContentStyles();
    const { borderedButton, middleContent } = useStyles();
    const push = useNavigate();
    const { next } = useRouteConfig(PATH.SIGNUP.HOME);
    const dispatch = useAppDispatch();
    const { fingerprint, fullStoryEnabled, newSearchUIEnabled } = useSelector(
        (state: AppState) => ({
            fingerprint: state.Signup.fingerprint,
            fullStoryEnabled: state.FeatureFlagging.features[Features.FULLSTORY],
            newSearchUIEnabled: state.FeatureFlagging.features[Features.SEARCH_UI_V2],
        }),
    );

    const onClickDonor = () => {
        pushEvent(DONOR_SIGNUP_BUTTON_CLICKED);
        window.location.href = GIVELIFY_DONOR_SIGNUP_PAGE_URL;
    };

    const onClick = () => {
        pushEvent(CLICK_START_BUTTON);
        next && push(next);
    };

    useEffect(() => {
        pushEvent(PAGE_ORGANIZATION_HOME, {
            gp_signup_verification_ui: newSearchUIEnabled,
        });
    }, [newSearchUIEnabled]);
    useEffect(() => {
        const { search } = location;
        if (!search) return;
        const queryString = queryStringParser(search);
        dispatch(
            // marketing team asked to track these three params for now
            // https://givelify.sharepoint.com/:x:/g/EbXWR5BcZ3hOm0FIbawifnEB0GftyK1r-pkLtwFWAT-rAQ?e=0UXQ50
            signSetAction({
                queryString: search,
                utmCampaign: queryString['utm_campaign'],
                utmSource: queryString['utm_source'],
                utmMedium: queryString['utm_medium'],
            }),
        );
    }, [dispatch, location]);
    useFullStoryIdentity({
        enabled: fullStoryEnabled,
        fingerprint,
    });

    return (
        <Grid container className={content}>
            <Grid item className="top-grid">
                <MiddleContent
                    topNode={<Logo className={logo} />}
                    heading={t('signup.home.heading')}
                    className={middleContent}
                    maxWidth={800}
                >
                    <div
                        className={`${borderedButton} margin-bottom`}
                        onClick={onClick}
                    >
                        <div className="text">
                            {t('signup.home.continueToDoneeSignup')}
                        </div>
                    </div>
                    <div className={borderedButton} onClick={onClickDonor}>
                        <div className="text">
                            {t('signup.home.continueToDonorSignup')}
                        </div>
                    </div>
                </MiddleContent>
            </Grid>
        </Grid>
    );
};

export default SignupHome;
